import React,{useState,useEffect} from 'react'
import { MultiLevelSidebar } from '../Components/Layout/Sidebar'
import EditEventForm from '../Components/Events/EditEventForm'
import { getDownloadURL } from 'firebase/storage'
import {
    ref as storageRef,
    uploadBytesResumable,
    listAll,
  } from "firebase/storage";
  import { ref, onValue, get,set,push,update} from "firebase/database";
import { db, storage } from '../firebase.config';
import { addDoc, collection, doc, getDoc, updateDoc } from 'firebase/firestore';
import { useParams,useNavigate } from 'react-router-dom';

const EditEvent = () => {
    const {id} = useParams()
    const navigate=useNavigate();
    const [eventName, setEventName] = useState("")
    const [eventLocation, setEventLocation] = useState("")
    const [eventYoutube, setEventYoutube] = useState("")
    const [eventUrl, setEventUrl] = useState("")
    const [eventMap, setEventMap] = useState("")
    const [eventPrice, setEventPrice] = useState("")
    const [eventDate, setEventDate] = useState("")
    const [eventDescription, setEventDescription] = useState("")
    const [eventStatus, setEventStatus] = useState("")
    const [coverImage, setCoverImage] = useState("")
    const [banner, setBanner] = useState("")

    const addCoverImage = (e) =>{
        e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `files/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
       setCoverImage(downloadURL)
         console.log(downloadURL)
       });
     }
   );
    }
    const addBannerImage = (e) =>{
        e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `files/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
       setBanner(downloadURL)
         
       });
     }
   );
    }
    const addEvents = () =>{
        const docRef = doc(db, "events",id);
        updateDoc(docRef,{
       name: eventName,
       price: eventPrice,
       location: eventLocation,
       map: eventMap,
       description: eventDescription,
       status: eventStatus,
       youtubeId: eventYoutube,
       banner:banner,
       coverImage:coverImage,
       bookingUrl:eventUrl,
       date:eventDate,

    })
  
   navigate("/events")
    }
    const fetchEvents = async () =>{
        const docRef = doc(db, "events", id);
const docSnap = await getDoc(docRef);
      
if (docSnap.exists()) {
  console.log("Document data:", docSnap.data());
  const data = docSnap.data()
  setEventName(data?.name)
    setEventPrice(data?.price)
   setEventLocation(data?.location)
   setEventMap(data?.map)
   setEventDescription(data?.description)
   setEventStatus(data?.status)
   setEventYoutube(data?.youtubeId)
   setBanner(data?.banner)
   setCoverImage(data?.coverImage)
   setEventUrl(data?.bookingUrl)
   setEventDate(data?.date)
} else {
  // docSnap.data() will be undefined in this case
  console.log("No such document!");
}
    }
    useEffect(() => {
     fetchEvents()
    
      
    }, [])
    
  return (
    <div className='bg-gray-200' >
        <MultiLevelSidebar />
        <EditEventForm   eventName={eventName} setEventName={setEventName}
        eventLocation={eventLocation} setEventLocation={setEventLocation}
        eventYoutube={eventYoutube} setEventYoutube={setEventYoutube}
        eventUrl={eventUrl} setEventUrl={setEventUrl}
        eventMap={eventMap} setEventMap={setEventMap}
        coverImage={coverImage} setCoverImage={setCoverImage}
        eventPrice={eventPrice} setEventPrice={setEventPrice}
        eventDate={eventDate} setEventDate={setEventDate}
        eventDescription={eventDescription} setEventDescription={setEventDescription}
        eventStatus={eventStatus} setEventStatus={setEventStatus}
        banner={banner} setBanner={setBanner}
        addBanner={addBannerImage} addCoverImage={addCoverImage}
        addEvents={addEvents}  />
    </div>
  )
}

export default EditEvent